import { render, staticRenderFns } from "./modalEditarAfiliado.vue?vue&type=template&id=355e37ba&scoped=true"
import script from "./modalEditarAfiliado.vue?vue&type=script&lang=js"
export * from "./modalEditarAfiliado.vue?vue&type=script&lang=js"
import style0 from "./modalEditarAfiliado.vue?vue&type=style&index=0&id=355e37ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355e37ba",
  null
  
)

export default component.exports